import '@bigml/bmlapp/src/assets/icons/bmlapp/bmlapp-font.css'
import '@bigml/bmlapp/dist/bmlapp.css'

import BMLApp from '@bigml/bmlapp'
import Vue from 'vue'

Vue.use(BMLApp)
